/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Invalid_RangeInputs */

const en_admin_statistics_invalid_range = /** @type {(inputs: Admin_Statistics_Invalid_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a valid time period. The start date must not be after the end date.`)
};

const de_admin_statistics_invalid_range = /** @type {(inputs: Admin_Statistics_Invalid_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte einen gültigen Zeitraum wählen. Das Startdatum darf nicht nach dem Enddatum liegen.`)
};

/**
* | output |
* | --- |
* | "Please select a valid time period. The start date must not be after the end date." |
*
* @param {Admin_Statistics_Invalid_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_invalid_range = /** @type {((inputs?: Admin_Statistics_Invalid_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Invalid_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_invalid_range(inputs)
	return en_admin_statistics_invalid_range(inputs)
});